<template>
  <div class="tags-view-wrapper">
    <!-- 标签页滚动容器 -->
    <scroll-pane ref="scrollPane" class="tags-view-container">
      <router-link v-for="tag in visitedViews" ref="tag" :key="tag.path" :class="['tags-view-item', {
        active: isActive(tag),
        affix: tag.meta && tag.meta.affix
      }]" :to="{
          path: tag.path,
          query: tag.query
        }" tag="span" @click.middle.native="!tag.meta || !tag.meta.affix ? closeSelectedTag(tag) : ''">
        {{ tag.meta && tag.meta.title ? tag.meta.title : tag.name }}
        <!-- 关闭按钮，固定标签页不显示关闭按钮 -->
        <span v-if="!tag.meta || !tag.meta.affix" class="el-icon-close"
          @click.prevent.stop="closeSelectedTag(tag)"></span>
      </router-link>
    </scroll-pane>
    <!-- 右键菜单 -->
    <ul v-show="visible" :style="{
      left: left + 'px',
      top: top + 'px'
    }" class="contextmenu">
      <li v-if="!selectedTag.meta || !selectedTag.meta.affix" @click="closeSelectedTag(selectedTag)">
        <i class="el-icon-close"></i> 关闭
      </li>
      <li @click="closeOthersTags(selectedTag)">
        <i class="el-icon-close"></i> 关闭其他
      </li>
      <li @click="closeAllTags(selectedTag)">
        <i class="el-icon-close"></i> 关闭所有
      </li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane' // 导入滚动容器组件

export default {
  name: 'TagsView',
  components: {
    ScrollPane // 注册滚动容器组件
  },
  data() {
    return {
      visible: false, // 右键菜单是否可见
      top: 0, // 右键菜单的top位置
      left: 0, // 右键菜单的left位置
      selectedTag: {}, // 当前选中的标签页
      affixTags: [] // 固定的标签页
    }
  },
  computed: {
    // 从store中获取已访问的标签页
    visitedViews() {
      return this.$store.state.app.visitedViews
    }
  },
  watch: {
    // 监听路由变化，添加新的标签页
    $route: {
      handler(to) {
        this.addTag(to) // 添加标签页
        this.moveToCurrentTag() // 滚动到当前标签页
      },
      immediate: true // 立即执行一次
    }
  },
  mounted() {
    // 初始化固定标签页
    this.initAffixTags()
    // 监听右键菜单的显示和隐藏
    this.$refs.scrollPane.$el.addEventListener('contextmenu', this.openMenu)
  },
  beforeDestroy() {
    // 移除右键菜单的监听
    this.$refs.scrollPane.$el.removeEventListener('contextmenu', this.openMenu)
  },
  methods: {
    // 初始化固定标签页
    initAffixTags() {
      // 从路由配置中获取固定的标签页
      this.affixTags = this.$router.options.routes.filter(route => route.meta && route.meta.affix)
      // 将固定标签页添加到已访问列表中
      for (const tag of this.affixTags) {
        this.$store.dispatch('addVisitedView', tag)
      }
    },
    // 添加标签页
    addTag(view) {
      // 如果标签页已经存在，则更新它
      this.$store.dispatch('updateVisitedView', view)
      // 如果标签页不存在，则添加它
      if (!this.isTagExisted(view)) {
        this.$store.dispatch('addVisitedView', view)
        // 如果需要缓存，则添加到缓存列表
        if (view.meta && view.meta.keepAlive) {
          this.$store.dispatch('addCachedView', view)
        }
      }
    },
    // 检查标签页是否已存在
    isTagExisted(view) {
      return this.visitedViews.some(tag => tag.path === view.path)
    },
    // 检查标签页是否为当前活跃的
    isActive(tag) {
      return tag.path === this.$route.path
    },
    // 滚动到当前标签页
    moveToCurrentTag() {
      setTimeout(() => {
        const tags = this.$refs.tag
        let activeTag = null
        // 找到当前活跃的标签页
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            activeTag = tag
            break
          }
        }
        // 如果找到了当前活跃的标签页，则滚动到它的位置
        if (activeTag) {
          this.$refs.scrollPane.moveToTarget(activeTag)
        }
      }, 100)
    },
    // 打开右键菜单
    openMenu(e) {
      e.preventDefault() // 阻止默认的右键菜单
      // 找到当前点击的标签页元素，处理点击子元素的情况
      let target = e.target
      // 向上查找，直到找到包含 tags-view-item 类的元素
      while (target && !target.classList.contains('tags-view-item')) {
        target = target.parentNode
        // 如果已经找到最顶层元素还没找到，退出循环
        if (!target || target === document.body) {
          target = null
          break
        }
      }
      if (target) {
        const tag = this.getTagFromEvent(target) // 从事件中获取标签页
        if (tag) {
          this.showContextMenu(tag, e.clientX, e.clientY) // 显示右键菜单
        }
      }
    },
    // 从事件中获取标签页
    getTagFromEvent(target) {
      // 获取标签页的 to 属性对应的 path
      // 由于 router-link 可能渲染为不同的元素，我们需要从标签内容或其他方式获取路径
      // 这里通过遍历 visitedViews 列表，根据标签文本匹配对应的标签页
      const tagText = target.textContent.trim().replace(/×|\s*$/, '') // 去除文本前后空格和关闭按钮
      // 从已访问列表中找到对应的标签页
      return this.visitedViews.find(tag => {
        const tagTitle = tag.meta && tag.meta.title ? tag.meta.title : tag.name
        return tagTitle && tagText.includes(tagTitle)
      })
    },
    // 显示右键菜单
    showContextMenu(tag, x, y) {
      this.visible = true // 设置右键菜单可见
      this.selectedTag = tag // 设置当前选中的标签页
      this.left = x // 设置右键菜单的left位置
      this.top = y // 设置右键菜单的top位置
      // 监听点击事件，点击其他地方隐藏右键菜单
      document.body.addEventListener('click', this.closeMenu)
    },
    // 关闭右键菜单
    closeMenu() {
      this.visible = false // 设置右键菜单不可见
      // 移除点击事件的监听
      document.body.removeEventListener('click', this.closeMenu)
    },

    // 关闭选中的标签页
    closeSelectedTag(view) {
      // 调用store中的action关闭标签页
      this.$store.dispatch('delVisitedView', view)
      this.$store.dispatch('delCachedView', view)
      // 关闭右键菜单
      this.closeMenu()
      // 如果关闭的是当前活跃的标签页，则跳转到上一个标签页
      if (this.isActive(view)) {
        this.toLastView()
      }
    },
    // 跳转到上一个标签页
    toLastView() {
      const visitedViews = this.visitedViews
      // 当关闭当前标签后，visitedViews数组已经更新
      // 直接获取更新后的visitedViews数组的最后一个元素作为目标标签
      // 这样确保在标签关闭后能跳转到前一个有效的标签页
      let lastView = null
      if (visitedViews.length > 0) {
        // 当关闭当前标签后，直接跳转到更新后的visitedViews数组的最后一个标签
        // 这是因为visitedViews数组按访问顺序排列，最后一个是最近访问的有效标签
        lastView = visitedViews[visitedViews.length - 1]
      }
      // 如果找到了上一个标签页，则跳转到它
      if (lastView) {
        this.$router.push({
          path: lastView.path,
          query: lastView.query
        })
      }
    },
    // 关闭其他标签页
    closeOthersTags(view) {
      // 调用store中的action关闭其他标签页
      this.$store.dispatch('delOthersVisitedViews', view)
      this.$store.dispatch('delOthersCachedViews', view)
      // 关闭右键菜单
      this.closeMenu()
      // 滚动到当前标签页
      this.moveToCurrentTag()
    },
    // 关闭所有标签页
    closeAllTags(view) {
      // 调用store中的action关闭所有标签页
      this.$store.dispatch('delAllVisitedViews')
      this.$store.dispatch('delAllCachedViews')
      // 关闭右键菜单
      this.closeMenu()
      // 如果当前标签页不是固定标签页，则跳转到第一个固定标签页
      if (!view.meta || !view.meta.affix) {
        const firstAffixTag = this.affixTags[0]
        if (firstAffixTag) {
          this.$router.push(firstAffixTag.path)
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
// 标签页容器的样式
.tags-view-wrapper {
  position: relative;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);

  // 标签页滚动容器的样式
  .tags-view-container {
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    height: 100%;

    // 标签页的样式
    .tags-view-item {
      display: inline-block;
      padding: 0 12px;
      height: 100%;
      margin-right: 4px;
      cursor: pointer;
      border-radius: 4px 4px 0 0;
      transition: all 0.2s ease;

      // 活跃标签页的样式
      &.active {
        background-color: #e6f7ff;
        color: #1890ff;
        border-bottom: 2px solid #1890ff;
      }

      // 固定标签页的样式
      &.affix {
        background-color: #fafafa;
        color: #666;
      }

      // 标签页悬停时的样式
      &:hover {
        background-color: #f5f7fa;
      }

      // 固定标签页悬停时的样式
      &.affix:hover {
        background-color: #f0f0f0;
      }

      // 标签页关闭按钮的样式
      .el-icon-close {
        margin-left: 4px;
        font-size: 14px;
        opacity: 0.7;
        transition: all 0.2s ease;

        // 关闭按钮悬停时的样式
        &:hover {
          opacity: 1;
          color: #ff4d4f;
        }
      }
    }
  }
}

// 右键菜单的样式
.contextmenu {
  position: fixed;
  z-index: 9999;
  width: 150px;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  list-style: none;
  margin: 0;

  // 右键菜单项的样式
  li {
    padding: 6px 16px;
    cursor: pointer;
    transition: all 0.2s ease;

    // 右键菜单项悬停时的样式
    &:hover {
      background-color: #f5f7fa;
    }

    // 右键菜单项图标的样式
    i {
      margin-right: 6px;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TagsView/TagsView.vue